import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import { Button, Col, Form, Input, message, Modal, Row, Select, Space, Table, Checkbox } from "antd"
import { number } from "echarts";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { SelectStores } from "../../component/common/Selects"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../tool/axios"
import './css/MenuTemplate.css'

// 引入组件
import CustomerMenuReplace from './components/CustomerMenuReplace';

const layout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 16 },
};
const tailLayout = {
    wrapperCol: { offset: 3, span: 16 },
};

const { Option } = Select
const { Column } = Table

type project = {
    id: string
    item_name: string
}

// 界面渲染使用的格式
type stepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_day: number,
        food_row: {
            meal_times: number,
            menu_item_list: {
                menu_item_name: string | undefined,
                menu_item_id: string | undefined,
                menu_item_count: number
                is_high_price: number
                menu_item_replace_list?: {
                    menu_item_name?: string | undefined,
                    menu_item_id?: string | undefined,
                    menu_item_count?: number
                    is_high_price?: number
                }[]
            }[]
        }[]
    }[]
}[]

// 后端接受的格式
type backendStepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_day: number,
        meal_times: number,
        menu_item_list: {
            menu_item_name: string | undefined,
            menu_item_id: string | undefined,
            menu_item_count: number
        }[]
    }[]
}[]

type Prop = {
    had_fill:number // 0 无历史餐单数据  1 有
    check_in_id:string
    template_id:string|undefined
    stage:backendStepDataType[] | undefined
    hasReplaceMenuItem: boolean
    onFinish?: ()=>void
}

export default function (props:Prop) {
    // const params: { id: string } = useParams() 
    const [form] = Form.useForm()
    const [templateInitId, setTemplateInitId] = useState<string>()

    // 套餐下拉菜单数据
    const [selectNameData, setSelectNameData] = useState<project[]>([])
    let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))


    // 当前阶段
    const [currentStep, setCurrentStep] = useState<number>(0)
    // 当前天
    const [currentDay, setCurrentDay] = useState<number>(0)
    // 1天的餐次模板
    const foodRowTmp = [
        {
            meal_times: 1,
            menu_item_list: []
        },
        {
            meal_times: 2,
            menu_item_list: []
        },
        {
            meal_times: 3,
            menu_item_list: []
        },
        {
            meal_times: 4,
            menu_item_list: []
        },
        {
            meal_times: 5,
            menu_item_list: []
        },
        {
            meal_times: 6,
            menu_item_list: []
        },
    ]

    // 阶段模板
    const tempStepData = {
        // 阶段 阶段描述 高阶菜品数量
        stage_number: 0, stage_desc: undefined, high_price_item_count: 0,
        // 每天的餐次数据
        detail: [
            {
                which_day: 1, food_row: _.cloneDeep(foodRowTmp)
            }
        ]
    }
    const [stepData, setStepData] = useState<stepDataType>([
        {
            stage_number: 1, stage_desc: undefined, high_price_item_count: 0,
            detail: [
                {
                    which_day: 1, food_row: _.cloneDeep(foodRowTmp)
                }
            ]
        }
    ])
    const [stepBackendData, setStepBackendData] = useState<backendStepDataType>([])

    const [foodTypeList, setFoodTypeList] = useState<{
        menu_type_id: string,
        menu_type_name: string
    }[]>([])
    const [foodList, setFoodList] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number
    }[]>([])
    const [food, setFood] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number
    }>()

    // 客户是否可更换菜品
    const [isChangeDishes, setIsChangeDishes] = useState<boolean>(false)
    // 显示更换菜品弹窗
    const [visible, setVisible] = useState<boolean>(false)
    // 显示更换菜品餐次信息
    const [updateDishesInfo, setUpdateDishesInfo] = useState<{
        mealRowIndex: any,
        currentStep: any,
        currentDay: any,
        meal_times: any,
        meal_times_text: any,
        menu_item_list: any
    }>({
        mealRowIndex: undefined, // 当前操作的某一个餐次的下标
        currentStep: undefined, // 第几阶段
        currentDay: undefined, // 第几天
        meal_times: undefined, // 餐次
        meal_times_text: undefined, 
        menu_item_list: [] // 选择的菜品列表
    })

    // 显示更换二级菜品信息
    const [foodListModule, setFoodListModule] = useState<{
        menu_item_id: string,
        menu_item_name: string,
        is_high_price: number,
        menu_item_count: number
    }[]>([])

    // 接收更换的菜品数据
    const getUpdateFoodData = (updateFoodList:any) => {
        setStepData(_.cloneDeep(updateFoodList))
    }

    const getMealTimeText = (times: any) => {
        switch (times) {
            case 1:
                return '早餐（8:00）'
            case 2:
                return '加餐（10:00）'
            case 3:
                return '午餐（12:00）'
            case 4:
                return '间餐（15:00）'
            case 5:
                return '晚餐（18:00）'
            case 6:
                return '宵夜（20:00）'
        }
    }

    useEffect(()=>{
        // 直接导入某个菜单模板
        if(props.stage && props.stage.length>0){
            let stage:any = props.stage
            let newStepData: stepDataType = []
            for (let i = 0; i < stage.length; i++) {
                let detailArr: any = []
                let detail = stage[i].detail
                for (let j = 0; j < detail.length; j++) {
                    // 如果不存在
                    if (!detailArr.some((el: any) => el.which_day === detail[j].which_day)) {
                        let foodRow: any = _.cloneDeep(foodRowTmp)
                        foodRow.forEach((foodEl: any) => {
                            if (foodEl.meal_times === detail[j].meal_times) {
                                foodEl.menu_item_list = detail[j].menu_item_list
                            }
                        })
                        detailArr.push({
                            which_day: detail[j].which_day,
                            which_date:detail[j].which_date,
                            food_row: foodRow
                        })
                    } else { // 已存在天数和餐次，则追加该天具体餐次的菜品
                        let currentDetailArrRow = detailArr.filter((el: any) => el.which_day === detail[j].which_day)[0]
                        let currentDetailArrFoodRow = currentDetailArrRow.food_row
                        currentDetailArrFoodRow.forEach((el: any) => {
                            detail[j]['menu_item_replace_list'] = []
                            if (el.meal_times === detail[j].meal_times) {
                                el.menu_item_list.push(...detail[j].menu_item_list)
                            }
                        })
                    }
                }

                newStepData.push({
                    stage_number: stage[i].stage_number, stage_desc: stage[i].stage_desc, high_price_item_count: stage[i].high_price_item_count,
                    detail: detailArr
                })

                setStepData(newStepData)   
            }
            setIsChangeDishes(props.hasReplaceMenuItem)
        }
        // 创建空白菜单
        else {
            let foodRow: any = _.cloneDeep(foodRowTmp)
            // 循环添加 menu_item_replace_list 更换菜单字段
            foodRow.forEach((foodItem:any) => {
                foodItem.menu_item_list.forEach((mm:any) => {
                    mm['menu_item_replace_list'] = []
                })
            })
            setStepData([
                {
                    stage_number: 1, stage_desc: undefined, high_price_item_count: 0,
                    detail: [
                        {
                            which_day: 1, food_row: foodRow
                        }
                    ]
                }
            ])
        }
    },[props.stage, props.hasReplaceMenuItem])

    useEffect(() => {
        // 查询菜品
        baseAxiosNoInfo('/cooking_center/global/menu_type_list').then((res: any) => {
            res && setFoodTypeList(res)
        })
        // 查询套餐
        // baseAxiosNoInfo('/global/item_list', { params: { item_type: 3 } }).then((res: any) => {
        //     res && setSelectNameData(res)
        // })

        // 如果是编辑
        // if (params.id) {
        //     baseAxiosNoInfo('/cooking_center/menu_template/detail', { params: { template_init_id: params.id } }).then((res: any) => {
        //         if (res) {

        //             setTemplateInitId(res.template_init_id)
        //             form.setFieldsValue({
        //                 template_name: res.template_name,
        //                 belong_store_id: res.belong_store_id.split(','),
        //                 belong_item_id: res.belong_item_id.split(','),
        //             })

        //             // [
        //             //     {
        //             //         stage_number: number | undefined,
        //             //         stage_desc: string | undefined,
        //             //         high_price_item_count: number,
        //             //         detail: [
        //             //             {
        //             //                 which_day: number,
        //             //                 meal_times: number,
        //             //                 menu_item_list: [
        //             //                     {
        //             //                         menu_item_name: string | undefined,
        //             //                         menu_item_id: string | undefined,
        //             //                         menu_item_count: number
        //             //                     }
        //             //                 ]
        //             //              }
        //             //         ]
        //             //     }
        //             //  ]

        //             //      stage_number: 1, 
        //             //      stage_desc: undefined, 
        //             //      high_price_item_count: 0,
        //             //      detail: [
        //             //          {
        //             //              which_day: 1, 
        //             //              food_row: [
        //             //                {
        //             //                     meal_times: 1,
        //             //                     menu_item_list: [
        //             //                         {
        //             //                             menu_item_name:' string | undefined',
        //             //                             menu_item_id: '',
        //             //                             menu_item_count: ''
        //             //                         }
        //             //                     ]
        //             //                },
        //             //{
        //             //                     meal_times: 2,
        //             //                     menu_item_list: [
        //             //                         {
        //             //                             menu_item_name:' string | undefined',
        //             //                             menu_item_id: '',
        //             //                             menu_item_count: ''
        //             //                         }
        //             //                     ]
        //             //                },
        //             //             ]
        //             //          }
        //             //      ]

        //             // 转换后端返回的数据格式
        //             let stage = res.stage
        //             let newStepData: stepDataType = []
        //             for (let i = 0; i < stage.length; i++) {
        //                 let detailArr: any = []
        //                 let detail = stage[i].detail
        //                 for (let j = 0; j < detail.length; j++) {
        //                     // 如果不存在
        //                     if (!detailArr.some((el: any) => el.which_day === detail[j].which_day)) {
        //                         let foodRow: any = _.cloneDeep(foodRowTmp)
        //                         foodRow.forEach((foodEl: any) => {
        //                             if (foodEl.meal_times === detail[j].meal_times) {
        //                                 foodEl.menu_item_list = detail[j].menu_item_list
        //                             }
        //                         })
        //                         detailArr.push({
        //                             which_day: detail[j].which_day,
        //                             food_row: foodRow
        //                         })
        //                     } else { // 已存在天数和餐次，则追加该天具体餐次的菜品
        //                         let currentDetailArrRow = detailArr.filter((el: any) => el.which_day === detail[j].which_day)[0]
        //                         let currentDetailArrFoodRow = currentDetailArrRow.food_row
        //                         currentDetailArrFoodRow.forEach((el: any) => {
        //                             if (el.meal_times === detail[j].meal_times) {
        //                                 el.menu_item_list.push(...detail[j].menu_item_list)
        //                             }
        //                         })
        //                     }
        //                 }

        //                 newStepData.push({
        //                     stage_number: stage[i].stage_number, stage_desc: stage[i].stage_desc, high_price_item_count: stage[i].high_price_item_count,
        //                     detail: detailArr
        //                 })

        //             }
        //             // console.log(newStepData)
        //             setStepData(newStepData)

        //         }
        //     })
        // }
    }, [])

    const syncHighNum = (d:any)=>{
        // 同步高价菜品数量
        d.forEach((el:any,index:number)=>{
            let highNum = 0
            el.detail.forEach((el2:any,index2:number)=>{
                el2.food_row.forEach( (el3:any,index3:number) => {
                    el3.menu_item_list.forEach((el4:any,index4:number)=>{
                        if(el4.is_high_price===1 && el4.menu_item_count>0){
                            highNum += el4.menu_item_count
                        }
                    })
                })
            })
            el.high_price_item_count = highNum
        })
        // end
    }
    return <div className="common-level2-edit h-detail">
        <div className="modules-h2">
            <span>客户餐单</span>
            <div className="modules-checked">
                <Checkbox 
                    checked={isChangeDishes} 
                    onChange={() => setIsChangeDishes(!isChangeDishes)}>
                    客户是否可更换菜品
                </Checkbox>
            </div>
        </div>
    
        <div className="standard-food-detail">
           {/*  <Form {...layout} form={form}>
                <Form.Item name="template_name" label="餐单名称" >
                    <Input />
                </Form.Item>
                <Form.Item name="belong_store_id" label="门店" >
                    <SelectStores multiple width={600} />
                </Form.Item> 
                <Form.Item name="belong_item_id" label="适用套餐" >
                    <Select className="fl" virtual={false} mode="multiple" style={{ width: 600, marginRight: 12, marginBottom: 12 }} placeholder="套餐" >
                        {ItemNameOptions}
                    </Select>
                </Form.Item>
            </Form>*/}

            <Form {...layout}  >
                <Form.Item label="阶段" >
                    <div className="sf-tab-btns clear" >
                        {stepData.map((el, index: number) => <div className={index === currentStep ? 'current' : ''} onClick={() => {
                            setCurrentStep(index)
                            setCurrentDay(0)
                        }}>第{index + 1}阶段</div>)}
                        {stepData.length > 1 && <div title="只能删除最后1阶段" className="add" onClick={() => {
                            setCurrentStep(0)
                            let d = _.cloneDeep(stepData)
                            d.pop()
                            setStepData(d)
                        }}><DeleteOutlined /></div>}
                        <div className="add" onClick={() => {
                            let d = _.cloneDeep(stepData)
                            let tmp = _.cloneDeep(tempStepData)
                            tmp.stage_number = stepData.length + 1
                            d.push(tmp)
                            setStepData(d)
                        }}>添加阶段</div>
                    </div>
                </Form.Item>
            </Form>

            {/* 阶段内容 */}
            {/* <p style={{ textAlign: 'center' }}>第{currentStep + 1}阶段内容{ }</p> */}

            {stepData.map((step, stepIndex) => <div style={{ display: stepIndex === currentStep ? 'block' : 'none' }}>
                <Form {...layout}  >
                    <Form.Item label="阶段描述" >
                        <Input style={{ width: '300px' }} value={step.stage_desc} onChange={(e: any) => {
                            let d = _.cloneDeep(stepData)
                            d[stepIndex].stage_desc = e.target.value
                            setStepData(d)
                        }} />
                    </Form.Item>

                    <Form.Item label="当前阶段已配置高价菜品数量" >
                        <Input disabled value={stepData[stepIndex].high_price_item_count} style={{ width: '300px' }} />
                    </Form.Item>

                    <Form.Item label="添加菜品" >
                        <Space style={{ marginBottom: 14 }}>
                            {step.detail.map((stepDetailEl, detaiIndex: number) => <Button className={detaiIndex === currentDay ? 'sfday-tab-btns current' : 'sfday-tab-btns'} onClick={() => {
                                setCurrentDay(detaiIndex)
                            }}>第{detaiIndex + 1}天</Button>)}
                            {step.detail.length > 1 && <Button title="只能删除最后1天" onClick={() => {
                                let d = _.cloneDeep(stepData)
                                d[currentStep].detail.pop()
                                setStepData(d)
                                setCurrentDay(0)
                            }}><DeleteOutlined /></Button>}
                            <Button className="sfday-tab-btns add" onClick={() => {
                                let d = _.cloneDeep(stepData)
                                d[stepIndex].detail.push({
                                    which_day: step.detail.length + 1, food_row: _.cloneDeep(foodRowTmp)
                                })
                                setStepData(d)
                            }}>添加1天</Button>
                        </Space>
                        <div style={{ marginBottom: 14 }}>
                            <Select allowClear placeholder="选择菜品分类" style={{ maxWidth: 140, marginRight: 14 }} onChange={(v: string) => {
                                // 查询该分类下的菜品
                                baseAxiosNoInfo('/cooking_center/global/menu_item_list_by_type_id', {
                                    params: {
                                        menu_type_id: v
                                    }
                                }).then((res: any) => {
                                    res && setFoodList(res)
                                })
                            }}>
                                {foodTypeList.map(el => <Option value={el.menu_type_id}>{el.menu_type_name}</Option>)}
                            </Select>
                            <Select 
                                allowClear
                                showSearch 
                                style={{ maxWidth: 140 }} 
                                placeholder="选择菜品" 
                                onChange={(v: any) => {
                                    setFood(foodList.find(el => el.menu_item_id === v))
                                }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {foodList.map(el => <Option value={el.menu_item_id}>{el.menu_item_name}</Option>)}
                            </Select>
                        </div>

                        {/* 餐次菜品列表 */}
                        {step.detail.map((dayDetailRow, dayDetailIndex) => <Table style={{ display: dayDetailIndex === currentDay ? 'block' : 'none' }} bordered dataSource={dayDetailRow.food_row} pagination={false}>
                            <Column title="餐次" render={(v: any) => {
                                switch (v.meal_times) {
                                    case 1:
                                        return '早餐（8:00）'
                                    case 2:
                                        return '加餐（10:00）'
                                    case 3:
                                        return '午餐（12:00）'
                                    case 4:
                                        return '间餐（15:00）'
                                    case 5:
                                        return '晚餐（18:00）'
                                    case 6:
                                        return '宵夜（20:00）'
                                }
                            }}></Column>
                            <Column title={"具体菜品"} render={(v: any) => {
                                return <div>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        {dayDetailRow.food_row[v.meal_times - 1].menu_item_list.map((mealRow, mealRowIndex) => <li style={{ marginBottom: 10 }}>
                                            <Space>
                                                {mealRow.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}
                                                <span>{mealRow.menu_item_name}</span>
                                                <Input style={{ width: 60 }} size="small" value={mealRow.menu_item_count} onChange={(e: any) => {
                                                    // let d = _.cloneDeep(stepData)
                                                    // d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list[mealRowIndex].menu_item_count = e.target.value
                                                    // setStepData(d)

                                                    let num = Number(e.target.value)
                                                    if(!isNaN(num)){
                                                        let d = _.cloneDeep(stepData)
                                                        d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list[mealRowIndex].menu_item_count = num
                                                        // 同步高价菜品数量
                                                        syncHighNum(d)
                                                        setStepData(d)
                                                    }else{
                                                        message.error('必须填写数字')
                                                    }
                                                }} />
                                                
                                                <DeleteOutlined style={{ cursor: 'pointer' }} onClick={() => {
                                                    let d = _.cloneDeep(stepData)
                                                    // if (d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list[mealRowIndex].is_high_price === 1) {
                                                    //     d[currentStep].high_price_item_count--
                                                    // }
                                                    d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list.splice(mealRowIndex, 1)
                                                    // 同步高价菜品数量
                                                    syncHighNum(d)
                                                    setStepData(d)
                                                }} />
                                                {
                                                    isChangeDishes && (
                                                        <div className="updateDished">
                                                            <div className="updateDishedBtn">
                                                                <Button type="text" className="btns" 
                                                                    onClick={() => {
                                                                        let d = _.cloneDeep(stepData) // 深拷贝后的阶段数据
                                                                        let menuItemList = d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list
                                                                        // 设置弹窗菜品信息
                                                                        setUpdateDishesInfo({
                                                                            mealRowIndex: mealRowIndex,
                                                                            currentStep: currentStep, // 第几阶段
                                                                            currentDay: currentDay, // 第几天
                                                                            meal_times: v.meal_times, // 餐次下标
                                                                            meal_times_text: getMealTimeText(v.meal_times), // 餐次文本
                                                                            menu_item_list: menuItemList[mealRowIndex], // 选择的菜品列表
                                                                        })
                                                                        setVisible(true)
                                                                    }}
                                                                >更换菜品</Button>
                                                            </div>
                                                            <div className="updateDishedBody">
                                                                {
                                                                    mealRow.menu_item_replace_list?.length ? (
                                                                       <>
                                                                         <div className="updateDishedTitle">可更换为：</div>
                                                                            <div className="updateDishedList">
                                                                                {
                                                                                    mealRow.menu_item_replace_list.map((reItem:any) => (
                                                                                        <span key={reItem.menu_item_id}>{reItem.menu_item_name} X {reItem.menu_item_count}</span>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                       </>
                                                                    ) : ''
                                                                }
                                                                
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                
                                            </Space>
                                        </li>)}
                                    </ul>
                                    {/* 添加&&清空菜品操作 */}
                                    <Space style={{ marginTop: 8 }}>
                                        <Button size="small" onClick={() => {
                                            if (food) {
                                                let d = _.cloneDeep(stepData)
                                                if ((d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list).some(el => el.menu_item_id === food.menu_item_id)) {
                                                    message.error('菜品已存在该餐次当中')
                                                    return
                                                }
                                                d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list.push({
                                                    menu_item_name: food?.menu_item_name,
                                                    menu_item_id: food?.menu_item_id,
                                                    menu_item_count: 0,
                                                    is_high_price: food.is_high_price,
                                                    menu_item_replace_list: []
                                                })
                                                // if (food.is_high_price) {
                                                //     d[currentStep].high_price_item_count++
                                                // }
                                                setStepData(d)
                                            } else {
                                                message.error('必须先选择菜品分类和菜品')
                                            }
                                        }}>添加菜品</Button>
                                        <Button size="small" onClick={() => {
                                            let d = _.cloneDeep(stepData)
                                            // let arr = d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list
                                            // let highNum = arr.filter(arrEl => arrEl.is_high_price === 1).length
                                            d[currentStep].detail[currentDay].food_row[v.meal_times - 1].menu_item_list = []
                                            // d[currentStep].high_price_item_count = d[currentStep].high_price_item_count - highNum
                                            // 同步高价菜品数量
                                            syncHighNum(d)
                                            setStepData(d)
                                        }}>清空</Button>
                                    </Space>
                                </div>
                            }}></Column>
                        </Table>)}
                    </Form.Item>
                </Form>
            </div>)}

            <Form {...layout}  >
                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit" onClick={() => {

                        // 将数据格式转换为后端所需
                        function stepDataFormatToBackEnd(data: stepDataType): backendStepDataType {
                            // [{
                            //     stage_number: number | undefined,
                            //     stage_desc: string | undefined,
                            //     high_price_item_count: number,
                            //     detail: [
                            //           {
                            //                which_day: number,
                            //                meal_times: number,
                            //                menu_item_list: [
                            //                    {
                            //                       menu_item_name: string | undefined,
                            //                       menu_item_id: string | undefined,
                            //                       menu_item_count: number
                            //                    }
                            //                ]
                            //         ]
                            //     }
                            // }]

                            //      stage_number: 1, 
                            //      stage_desc: undefined, 
                            //      high_price_item_count: 0,
                            //      detail: [
                            //          {
                            //              which_day: 1, 
                            //              food_row: [
                            //                {
                            //                     meal_times: 1,
                            //                     menu_item_list: [
                            //                         {
                            //                             menu_item_name:' string | undefined',
                            //                             menu_item_id: '',
                            //                             menu_item_count: ''
                            //                         }
                            //                     ]
                            //                },
                            //{
                            //                     meal_times: 2,
                            //                     menu_item_list: [
                            //                         {
                            //                             menu_item_name:' string | undefined',
                            //                             menu_item_id: '',
                            //                             menu_item_count: ''
                            //                         }
                            //                     ]
                            //                },
                            //             ]
                            //          }
                            //      ]

                            let result: backendStepDataType = []

                            for (let i = 0; i < data.length; i++) { // 阶段
                                let detailArr: any = []

                                for (let j = 0; j < data[i].detail.length; j++) { // 每天餐次
                                    let frs = data[i].detail[j].food_row
                                    let isAllEmpty = frs.every((elt:any)=>elt.menu_item_list.length===0) 
                                
                                    if(isAllEmpty){
                                        message.error('每天至少一个餐次中存在一个菜品，否则不能提交。')
                                        return []
                                    }
                                    for (let k = 0; k < frs.length; k++) {
                                        if (frs[k].menu_item_list.length > 0) {
                                            if( frs[k].menu_item_list.every((el5:any)=>el5.menu_item_count<=0) ){
                                                message.error('单菜品的数量必须大于0，否则不能提交。')
                                                return  []
                                            }
                                            detailArr.push({
                                                which_day: data[i].detail[j].which_day,
                                                meal_times: frs[k].meal_times,
                                                menu_item_list: frs[k].menu_item_list
                                            })
                                        }
                                    }
                                }

                                result.push({
                                    stage_number: data[i].stage_number,
                                    stage_desc: data[i].stage_desc,
                                    high_price_item_count: data[i].high_price_item_count,
                                    detail: detailArr
                                })

                            }

                            return result
                        }

                        if (props.had_fill===1) {
                            baseAxiosComplete.post('/cooking_center/customer/menu/update', {
                                check_in_id: props.check_in_id,
                                has_replace_menu_item: isChangeDishes? 1: 0,
                                stage: stepDataFormatToBackEnd(stepData)
                            }).then((res: any) => {
                                if (res.status === 0) {
                                    //window.location.href = document.referrer
                                    props.onFinish && props.onFinish()
                                }
                            })
                        } else {
                            baseAxiosComplete.post('/cooking_center/customer/menu/add', {
                                check_in_id: props.check_in_id,
                                template_id: props.template_id,
                                has_replace_menu_item: isChangeDishes? 1: 0,
                                stage: stepDataFormatToBackEnd(stepData)
                            }).then((res: any) => {
                                if (res.status === 0) {
                                    //window.location.href = document.referrer
                                    props.onFinish && props.onFinish()
                                }
                            })
                        }
                    }}>
                        提交
                    </Button>
                </Form.Item>
            </Form>
        </div>

        {/* 更换菜品弹窗 */}
        <CustomerMenuReplace
            visibleModule={visible}
            updateStepData={stepData}
            updateDishesInfo={updateDishesInfo}
            foodTypeList={foodTypeList}
            onModuleCancel={(bool: any) => setVisible(bool)}
            onGetUpdateFoodData={getUpdateFoodData}
        />
    </div>
}